export const environment = () => {
    const origin = window.location.origin;
    //local
    // const apiUri = `http://localhost:8765`;
    const apiUri = `https://insideapi.drbitahosseini.com`;

    const server = `${apiUri}`;
    const api = `${apiUri}/api`;
    const showLink = origin === "https://inside.drbitahosseini.com";

    return {
        api,
        server,
        showLink
    }
}
